/**
 * Before you edit these, read the documentation on how these files are compiled:
 * https://docs.phpvms.net/developers/building-assets
 *
 * Edits here don't take place until you compile these assets and then upload them.
 */

export const PLAN_ROUTE_COLOR = '#8B008B';
export const ACTUAL_ROUTE_COLOR = '#45008a';
export const CIRCLE_COLOR = '#056093';
